interface LegendItem {
  key: string;
  label: string;
  color: string;
}

interface Props {
  /** 凡例項目（表示順・色は呼び出し側で解決済み。グラフの積み上げ順と一致させる） */
  items: LegendItem[];
}

/**
 * グループモード時のチャート右側凡例。
 * 件数が多い場合は max-height + overflow-y-auto で縦スクロール可能。
 * 並び順・色は呼び出し側（AnalysisFunnelChart）で積み上げの見た目に揃えて渡す。
 */
export default function FunnelChartLegend({ items }: Props) {
  if (items.length === 0) return null;

  return (
    <div className="max-h-[358px] w-[160px] shrink-0 overflow-y-auto py-2 pr-1">
      <ul aria-label="グループ凡例" className="space-y-2">
        {items.map((item) => (
          <li key={item.key} className="flex items-center gap-2">
            <span
              aria-hidden="true"
              className="size-4 shrink-0 rounded-sm"
              style={{ backgroundColor: item.color }}
            />
            <span className="truncate text-xs leading-[1.7] text-main" title={item.label}>
              {item.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
